(function() {
    window.c24.lp.ac.un = {
        init: function() {
            window.c24.lp.ac.addDefaultQtips('un');

            const $childrenCheckbox = $('input.children', '.mod24ac.un');
            const $childSelectContainer = $('select[name="childCount"]', '.mod24ac.un').parent();

            if ($childrenCheckbox.is(':checked')) {
                $childSelectContainer.removeClass('hidden');
            } else {
                $childSelectContainer.addClass('hidden');
            }

            $childrenCheckbox.on('change', function() {
                if ($(this).is(':checked')) {
                    $childSelectContainer.removeClass('hidden');
                } else {
                    $childSelectContainer.addClass('hidden');
                }
            });

            $('.mod24ac.un form').on('submit', function(e) {
                const form = $(e.target);
                const myself = $('input.myself', form).is(':checked');
                const partner = $('input.partner', form).is(':checked');
                const children = $('input.children', form).is(':checked');
                const childrenSelected = $('div:not(.hidden) select[name=childCount] option:selected', form);
                const childrenAmount = childrenSelected ? childrenSelected.val() : 0;

                $('input[name=myself]', form).val(myself ? 1 : 0);
                $('input[name=partner]', form).val(partner ? 1 : 0);
                $('input[name=kid]', form).val(children ? childrenAmount : 0);
            });
        },
    };

    $(document).ready(function() {
        window.c24.lp.ac.un.init();
    });
})();
